var _circle, _circle2, _circle3, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatusReminder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 46,
    cy: 46,
    r: 46,
    fill: "#FFC100"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 46,
    cy: 46,
    r: 38,
    fill: "#FFC100"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 46,
    r: 30,
    fill: "#FFC100"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46 52C45.0782 52 44.3152 51.2832 44.2577 50.3632L43.44 37.28L43.3809 34.6793C43.3475 33.2095 44.5298 32 46 32V32C47.4702 32 48.6525 33.2095 48.6191 34.6793L48.56 37.28L47.7423 50.3632C47.6848 51.2832 46.9218 52 46 52V52ZM46 62.2C45.1467 62.2 44.4267 61.92 43.84 61.36C43.28 60.8 43 60.0667 43 59.16C43 58.2533 43.2933 57.52 43.88 56.96C44.4667 56.4 45.1733 56.12 46 56.12C46.8267 56.12 47.5333 56.4 48.12 56.96C48.7067 57.52 49 58.2533 49 59.16C49 60.0667 48.7067 60.8 48.12 61.36C47.5333 61.92 46.8267 62.2 46 62.2Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusReminder);
export default __webpack_public_path__ + "static/media/status-reminder.12b87d1d9e9f43ce21e1af619ab76d0d.svg";
export { ForwardRef as ReactComponent };